import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_e1137352";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_e1137352" };
/** script content **/
require("./float-ball.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexe1137352%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ffloat-ball%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_e1137352"],
    ctorType: "component",
    outputPath: "components/indexe1137352/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
